/* TinySort *
  * TinySort is a small script that sorts HTML elements. It sorts by text- or attribute value, or by that of one of it's children.
  * @summary A nodeElement sorting script.
  * @version 2.3.6
  * @license MIT
  * @author Ron Valstar <ron@ronvalstar.nl>
  * @copyright Ron Valstar <ron@ronvalstar.nl>
  * @namespace tinysort
  */
  !function(e,t){"use strict";function r(){return t}"function"==typeof define&&define.amd?define("tinysort",r):e.tinysort=t}(this,function(){"use strict";function e(e,n){function s(){0===arguments.length?v({}):t(arguments,function(e){v(x(e)?{selector:e}:e)}),d=$.length}function v(e){var t=!!e.selector,n=t&&":"===e.selector[0],o=r(e||{},m);$.push(r({hasSelector:t,hasAttr:!(o.attr===l||""===o.attr),hasData:o.data!==l,hasFilter:n,sortReturnNumber:"asc"===o.order?1:-1},o))}function S(){t(e,function(e,t){M?M!==e.parentNode&&(k=!1):M=e.parentNode;var r=$[0],n=r.hasFilter,o=r.selector,a=!o||n&&e.matchesSelector(o)||o&&e.querySelector(o),l=a?R:V,s={elm:e,pos:t,posn:l.length};B.push(s),l.push(s)}),D=R.slice(0)}function y(e,t,r){for(var n=r(e.toString()),o=r(t.toString()),a=0;n[a]&&o[a];a++)if(n[a]!==o[a]){var l=Number(n[a]),s=Number(o[a]);return l==n[a]&&s==o[a]?l-s:n[a]>o[a]?1:-1}return n.length-o.length}function N(e){for(var t,r,n=[],o=0,a=-1,l=0;t=(r=e.charAt(o++)).charCodeAt(0);){var s=46==t||t>=48&&57>=t;s!==l&&(n[++a]="",l=s),n[a]+=r}return n}function C(e,r){var n=0;for(0!==p&&(p=0);0===n&&d>p;){var l=$[p],s=l.ignoreDashes?f:u;if(t(h,function(e){var t=e.prepare;t&&t(l)}),l.sortFunction)n=l.sortFunction(e,r);else if("rand"==l.order)n=Math.random()<.5?1:-1;else{var c=a,g=w(e,l),m=w(r,l),v=""===g||g===o,S=""===m||m===o;if(g===m)n=0;else if(l.emptyEnd&&(v||S))n=v&&S?0:v?1:-1;else{if(!l.forceStrings){var C=x(g)?g&&g.match(s):a,b=x(m)?m&&m.match(s):a;if(C&&b){var A=g.substr(0,g.length-C[0].length),F=m.substr(0,m.length-b[0].length);A==F&&(c=!a,g=i(C[0]),m=i(b[0]))}}n=g===o||m===o?0:l.natural&&(isNaN(g)||isNaN(m))?y(g,m,N):m>g?-1:g>m?1:0}}t(h,function(e){var t=e.sort;t&&(n=t(l,c,g,m,n))}),n*=l.sortReturnNumber,0===n&&p++}return 0===n&&(n=e.pos>r.pos?1:-1),n}function b(){var e=R.length===B.length;if(k&&e)O?R.forEach(function(e,t){e.elm.style.order=t}):M?M.appendChild(A()):console.warn("parentNode has been removed");else{var t=$[0],r=t.place,n="org"===r,o="start"===r,a="end"===r,l="first"===r,s="last"===r;if(n)R.forEach(F),R.forEach(function(e,t){E(D[t],e.elm)});else if(o||a){var c=D[o?0:D.length-1],i=c&&c.elm.parentNode,u=i&&(o&&i.firstChild||i.lastChild);u&&(u!==c.elm&&(c={elm:u}),F(c),a&&i.appendChild(c.ghost),E(c,A()))}else if(l||s){var f=D[l?0:D.length-1];E(F(f),A())}}}function A(){return R.forEach(function(e){q.appendChild(e.elm)}),q}function F(e){var t=e.elm,r=c.createElement("div");return e.ghost=r,t.parentNode.insertBefore(r,t),e}function E(e,t){var r=e.ghost,n=r.parentNode;n.insertBefore(t,r),n.removeChild(r),delete e.ghost}function w(e,t){var r,n=e.elm;return t.selector&&(t.hasFilter?n.matchesSelector(t.selector)||(n=l):n=n.querySelector(t.selector)),t.hasAttr?r=n.getAttribute(t.attr):t.useVal?r=n.value||n.getAttribute("value"):t.hasData?r=n.getAttribute("data-"+t.data):n&&(r=n.textContent),x(r)&&(t.cases||(r=r.toLowerCase()),r=r.replace(/\s+/g," ")),null===r&&(r=g),r}function x(e){return"string"==typeof e}x(e)&&(e=c.querySelectorAll(e)),0===e.length&&console.warn("No elements to sort");var D,M,q=c.createDocumentFragment(),B=[],R=[],V=[],$=[],k=!0,z=e.length&&e[0].parentNode,L=z.rootNode!==document,O=e.length&&(n===o||n.useFlex!==!1)&&!L&&-1!==getComputedStyle(z,null).display.indexOf("flex");return s.apply(l,Array.prototype.slice.call(arguments,1)),S(),R.sort(C),b(),R.map(function(e){return e.elm})}function t(e,t){for(var r,n=e.length,o=n;o--;)r=n-o-1,t(e[r],r)}function r(e,t,r){for(var n in t)(r||e[n]===o)&&(e[n]=t[n]);return e}function n(e,t,r){h.push({prepare:e,sort:t,sortBy:r})}var o,a=!1,l=null,s=window,c=s.document,i=parseFloat,u=/(-?\d+\.?\d*)\s*$/g,f=/(\d+\.?\d*)\s*$/g,h=[],d=0,p=0,g=String.fromCharCode(4095),m={selector:l,order:"asc",attr:l,data:l,useVal:a,place:"org",returns:a,cases:a,natural:a,forceStrings:a,ignoreDashes:a,sortFunction:l,useFlex:a,emptyEnd:a};return s.Element&&function(e){e.matchesSelector=e.matchesSelector||e.mozMatchesSelector||e.msMatchesSelector||e.oMatchesSelector||e.webkitMatchesSelector||function(e){for(var t=this,r=(t.parentNode||t.document).querySelectorAll(e),n=-1;r[++n]&&r[n]!=t;);return!!r[n]}}(Element.prototype),r(n,{loop:t}),r(e,{plugin:n,defaults:m})}());

document.addEventListener("DOMContentLoaded", function (event) {
  /*! FitText.js 1.2 */
    (function( $ ){
      $.fn.fitText = function( kompressor, options ) {

        // Setup options
        var compressor = kompressor || 1,
            settings = $.extend({
              'minFontSize' : Number.NEGATIVE_INFINITY,
              'maxFontSize' : Number.POSITIVE_INFINITY
            }, options);

        return this.each(function(){

          // Store the object
          var $this = $(this);

          // Resizer() resizes items based on the object width divided by the compressor * 10
          var resizer = function () {
            $this.css('font-size', Math.max(Math.min($this.width() / (compressor*10), parseFloat(settings.maxFontSize)), parseFloat(settings.minFontSize)));
          };

          // Call once to set.
          resizer();

          // Call on resize. Opera debounces their resize by default.
          $(window).on('resize.fittext orientationchange.fittext', resizer);

        });

      };
    })( jQuery );

  /*! Actual Height 1.0.18 */
    /*! - Copyright 2012, Ben Lin (http://dreamerslab.com/) - Licensed under the MIT License (LICENSE.txt). - Requires: jQuery >= 1.2.3 */
    (function(a){if(typeof define==="function"&&define.amd){define(["jquery"],a);
    }else{a(jQuery);}}(function(a){a.fn.addBack=a.fn.addBack||a.fn.andSelf;a.fn.extend({actual:function(b,l){if(!this[b]){throw'$.actual => The jQuery method "'+b+'" you called does not exist';
    }var f={absolute:false,clone:false,includeMargin:false,display:"block"};var i=a.extend(f,l);var e=this.eq(0);var h,j;if(i.clone===true){h=function(){var m="position: absolute !important; top: -1000 !important; ";
    e=e.clone().attr("style",m).appendTo("body");};j=function(){e.remove();};}else{var g=[];var d="";var c;h=function(){c=e.parents().addBack().filter(":hidden");
    d+="visibility: hidden !important; display: "+i.display+" !important; ";if(i.absolute===true){d+="position: absolute !important; ";}c.each(function(){var m=a(this);
    var n=m.attr("style");g.push(n);m.attr("style",n?n+";"+d:d);});};j=function(){c.each(function(m){var o=a(this);var n=g[m];if(n===undefined){o.removeAttr("style");
    }else{o.attr("style",n);}});};}h();var k=/(outer)/.test(b)?e[b](i.includeMargin):e[b]();j();return k;}});}));

  /*! Lazy Load 1.9.7 - MIT license - Copyright 2010-2015 Mika Tuupola - http://www.appelsiini.net/projects/lazyload */
  !function(a,b,c,d){var e=a(b);a.fn.lazyload=function(f){function g(){var b=0;i.each(function(){var c=a(this);if(!j.skip_invisible||c.is(":visible"))if(a.abovethetop(this,j)||a.leftofbegin(this,j));else if(a.belowthefold(this,j)||a.rightoffold(this,j)){if(++b>j.failure_limit)return!1}else c.trigger("appear"),b=0})}var h,i=this,j={threshold:0,failure_limit:0,event:"scroll",effect:"show",container:b,data_attribute:"original",skip_invisible:!1,appear:null,load:null,placeholder:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"};return f&&(d!==f.failurelimit&&(f.failure_limit=f.failurelimit,delete f.failurelimit),d!==f.effectspeed&&(f.effect_speed=f.effectspeed,delete f.effectspeed),a.extend(j,f)),h=j.container===d||j.container===b?e:a(j.container),0===j.event.indexOf("scroll")&&h.bind(j.event,function(){return g()}),this.each(function(){var b=this,c=a(b);b.loaded=!1,(c.attr("src")===d||c.attr("src")===!1)&&c.is("img")&&c.attr("src",j.placeholder),c.one("appear",function(){if(!this.loaded){if(j.appear){var d=i.length;j.appear.call(b,d,j)}a("<img />").bind("load",function(){var d=c.attr("data-"+j.data_attribute);c.hide(),c.is("img")?c.attr("src",d):c.css("background-image","url('"+d+"')"),c[j.effect](j.effect_speed),b.loaded=!0;var e=a.grep(i,function(a){return!a.loaded});if(i=a(e),j.load){var f=i.length;j.load.call(b,f,j)}}).attr("src",c.attr("data-"+j.data_attribute))}}),0!==j.event.indexOf("scroll")&&c.bind(j.event,function(){b.loaded||c.trigger("appear")})}),e.bind("resize",function(){g()}),/(?:iphone|ipod|ipad).*os 5/gi.test(navigator.appVersion)&&e.bind("pageshow",function(b){b.originalEvent&&b.originalEvent.persisted&&i.each(function(){a(this).trigger("appear")})}),a(c).ready(function(){g()}),this},a.belowthefold=function(c,f){var g;return g=f.container===d||f.container===b?(b.innerHeight?b.innerHeight:e.height())+e.scrollTop():a(f.container).offset().top+a(f.container).height(),g<=a(c).offset().top-f.threshold},a.rightoffold=function(c,f){var g;return g=f.container===d||f.container===b?e.width()+e.scrollLeft():a(f.container).offset().left+a(f.container).width(),g<=a(c).offset().left-f.threshold},a.abovethetop=function(c,f){var g;return g=f.container===d||f.container===b?e.scrollTop():a(f.container).offset().top,g>=a(c).offset().top+f.threshold+a(c).height()},a.leftofbegin=function(c,f){var g;return g=f.container===d||f.container===b?e.scrollLeft():a(f.container).offset().left,g>=a(c).offset().left+f.threshold+a(c).width()},a.inviewport=function(b,c){return!(a.rightoffold(b,c)||a.leftofbegin(b,c)||a.belowthefold(b,c)||a.abovethetop(b,c))},a.extend(a.expr[":"],{"below-the-fold":function(b){return a.belowthefold(b,{threshold:0})},"above-the-top":function(b){return!a.belowthefold(b,{threshold:0})},"right-of-screen":function(b){return a.rightoffold(b,{threshold:0})},"left-of-screen":function(b){return!a.rightoffold(b,{threshold:0})},"in-viewport":function(b){return a.inviewport(b,{threshold:0})},"above-the-fold":function(b){return!a.belowthefold(b,{threshold:0})},"right-of-fold":function(b){return a.rightoffold(b,{threshold:0})},"left-of-fold":function(b){return!a.rightoffold(b,{threshold:0})}})}(jQuery,window,document);
});

/* extend number.prototype to allow for currency formatting */
  /**
   * Number.prototype.format(n, x)
   *
   * @param integer n: length of decimal
   * @param integer x: length of sections
   */
  Number.prototype.format = function(n, x) {
    var re = '(\\d)(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$1,');
  };

///////////////////////////////////////////////////////////
// Initialization Functions (only run once)
///////////////////////////////////////////////////////////

  // get the page ready for the builder
  function initPage() {
    // add class to html element
    $('html').addClass('watch-builder')

    // replace mobile header vortic logo with the back to site image
    $('#header .mobile_logo.logo img').attr('src', '//vorticwatches.com/cdn/shop/t/48/assets/back-to-site.png?v=69444').attr('data-src', '//vorticwatches.com/cdn/shop/t/48/assets/back-to-site.png?v=69444');

    // insert the back to store button into the mobile header
    var backButton = '<a href="/collections/watches?filter=true&cat=.aas" class="back-to-store"><svg class="svg-inline--fa fa-chevron-left" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path fill="currentColor" d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></i><span>Back to Store</span></div>';
    $('.header-nav').prepend(backButton);

    // remove unnecessary/hidden page elements
    $('.contact-bar').remove();
    $('#shopify-section-site-footer').remove();
    $('#shopify-section-site-press').remove();
    $('#shopify-section-site-affirm').remove();
    $('.eyebrow-cta-link').remove();

    // triggered on window resize
    $(window).resize(function() {
      alignElements('resize');
    });
  }

  // set up the builder
  function initBuilder() {
    // triggered when the page is completely loaded
    $(window).bind("load", function() {
      // console.log('window load complate');
      // double check to make sure the page is fully loaded before moving forward
      var readyStateCheckInterval = setInterval(function() {
        if(document.readyState == 'complete') {
          // console.log('readyState complete!');
          // clear the interval once the condition is met
          clearInterval(readyStateCheckInterval);

          // check to see if the URL contains arguments for a saved watch
          // if valid components are in the URL, initialize the builder with those components
          if(isSaved()) {
            // console.log('initSavedBuild');
            initSavedBuild();
          }

          initOptionsContainer();

          showBuilder();
        } else {
          // console.log('not ready yet');
        }
      }, 250);
    });
  }

  // parse the url to see if any save arguments are present, returns true or false
  function isSaved() {
    // console.log('checking args');
    // check for saved option URL arguments. every option must be present for the saved watch to populate properly
    if(urlParse('dial') == undefined ||
      urlParse('case') == undefined || urlParse('crown') == undefined ||
      urlParse('strap') == undefined || urlParse('engrave') == undefined) {

      // reset the url
      builderUrlHandler('reset');

      return false;
    } else {
      // get the ID of the given dial
      var theDial = '#' + urlParse('dial');

      // check to see if the given dial is still available in the builder
      if($(theDial).length != 0) {
        // the given dial is available, so display the default message
        vex.dialog.buttons.YES.text = 'Okay';
        vex.dialog.alert({
          message: '<p>You&#39;re viewing a watch with previously selected options. Click the button below to go back and make changes or order this watch as-is. Copy and save the URL to come back to this build in the future.</p>',
          contentClassName: 'bv3-popover',
          className: 'vex-theme-default'
        });

        // switch to the review view
        changeView('review');
      } else {
        // the given dial is no longer available in the builder, so display a special message to the user
        vex.dialog.buttons.YES.text = 'Select a New Dial';
        vex.dialog.alert({
          message: '<p>You&#39;re viewing a previously saved watch. Unfortunately the dial that was previously selected is no longer available so you will need to select a different one.</p>',
          contentClassName: 'bv3-popover',
          className: 'vex-theme-default'
        });

        // switch to the dial view
        changeView('dial');
      }

      return true;
    }
  }

  // select options passed through URL arguments to load a saved build
  function initSavedBuild() {
    // based on the passed URL arguments...
    // console.log('loading saved watch...');

    // select the dial (if the saved dial is no longer available, this will do nothing)
    $('.bv3-dial a[data-image-id=' + urlParse('dial') + ']').trigger('click');

    // select the case
    $('.bold_option_value_title:contains("' + urlParse("case") + '")').trigger('click');

    // select the crown
    $('.bold_option_value_title:contains("' + urlParse("crown") + '")').trigger('click');

    // select the strap
    $('.bold_option_value_title:contains("' + urlParse("strap") + '")').trigger('click');

    // select the engraving options
    $('.bold_option_title:contains("Engraving")').next().find('.bold_option_value').each(function(index){
      if(index == 0 && urlParse('engrave') == 'true') {
        $(this).find('.bold_option_value_element input[type=checkbox]').trigger('click');
        // console.log(index + ' triggered');
      }
    });

    // trigger visual component update
    updateComponents();
  }

  // set up the options container functionality
  function initOptionsContainer() {
    // bind a change event to the form radio options for components
    $('#AddToCartForm .bold_option_set input[type=radio]').on('change', function(){ updateComponents(); });

    // bind a change event to the form checkboxes for the engraving options
    $('#AddToCartForm .bold_option_set input[type=checkbox]').on('change', function(){ updateComponents(); });

    // bind a change event to each of the engraving option text fields
    $('.engraving-option-text').each(function(){
      $(this).on('change', function(){
        // if the option isn't already selected and if the field value isn't blank, select the corresponding engraving option
        if(!$(this).parents('.option-parent').find('.option-image').hasClass('option-selected') && $(this).val() != ""){
          $(this).parents('.option-parent').find('.option-image').trigger('click');
        }

        // copy the contents of the field to the hidden line item property field
        var string = $(this).val(),
            stringEscaped = string.replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0'),
            stringUppercase = stringEscaped.toUpperCase();
        $('#engraving-text-' + $(this).attr('data-id')).val(stringUppercase);
        // console.log(stringUppercase);
      });
    });

    // set up the cart button in the review view to trigger the actual cart button on click
    $('#reviewCartBtn').on('click', function(){
      // clear the engraving line item values if the corresponding option has been unchecked
      $('.engraving-option-text').each(function(){
        if($(this).parents('.option-parent').find('.option-image').hasClass('option-selected') == false){
          $('#engraving-text-' + $(this).attr('data-id')).val('');
        }
      });

      // submit the form

      // BOLD POV2
      // $('#AddToCartForm').trigger('submit');
      $('#AddToCartForm').find("[type='submit']:not(.bold_hidden)").click();
      // BOLD POV2
    });

    // sort the dial/movement variants by price
    tinysort('.bv3-dial',{attr:'data-price'});

    // set up lazy loading for the dial/movement variant images
    $('.options-content-section .bv3-dial img.option-dial').lazyload({
      effect : 'fadeIn',
      container: $('.options-dial .options-content-section'),
      failure_limit : 20,
      event : "tricky"
    });

    // start the dial thumb images loading
    // (this effectively tricks the browser to load the core builder faster, loading the variant images right after everything else is loaded)
    var timeout = setTimeout(function() {
      $('.options-content-section .bv3-dial img.option-dial').trigger('tricky');
    }, 3000);

    // hide the last dial divider visually, but keep it there to act as bottom padding
    $('.dial-divider:last').css('opacity','0');

    // loop through each link in the options blocks and set them to open in a new window
    $('.bv3-options-block a').each(function(){
      $(this).attr('target','_blank');
    });

    // // set up the button to save the save url to clipboard
    // var clipboard = new ClipboardJS('.save-url-input');
    // clipboard.on('success', function(e){
    //   $('.url-copy-alert').slideDown();
    // });
    //
    // clipboard.on('error', function(e){
    //   $('.url-copy-alert').text('There was a problem, try copying the text directly.').slideDown();
    // });

    // POST form data to zapier on submission of shareFormSelf
    $('#shareFormSelf').submit(function(e){
      e.preventDefault();
      $.ajax({
          url: 'https://hooks.zapier.com/hooks/catch/1578588/nl62d9/',
          type: 'post',
          data: $('#shareFormSelf').serialize(),
          success: function(){
            $('.share-form').slideUp();
            $('.share-error').slideUp();
            $('.share-success').slideDown();
            // reset the field values to blank
            $('#shareFormSelf .share-name').val('');
            $('#shareFormSelf .share-email').val('');
          },
          error: function(){
            $('.share-error').slideDown();
          }
      });
    });
  }

  // animate in the builder elements
  function showBuilder() {
    // slide in the options container
    $('.bv3-options-container').css({'right':'0px'});

    // on a delay slide in the watch container
    setTimeout(function() {
      $('.bv3-watch-container').css({'margin-left':'0px'});
      alignElements('showBuilder (on delay)');

      // show the scroll indicator if the view can be scrolled
      if(isScrollable('.options-welcome')){
        $('.options-welcome .scroll-icon').delay(3000).fadeIn(); // on a delay
        // fade it out once the user starts scrolling
        $('.options-welcome').one('scroll', function(){ $(this).find('.scroll-icon').fadeOut(); });
      }
    }, 1000);

    // hide the loader gif
    loaderHandler(true);
  }


///////////////////////////////////////////////////////////
// Core Functions (run frequently)
///////////////////////////////////////////////////////////

  // pulls arguments passed through the page URL
  function urlParse(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
      }
    }
    // console.log('Query variable "%s" not found', variable);
  }

  // handles switching between watch and option select contexts on mobile
  function mobileShowWatch(view) {
    // remove the attention class
    $('.bv3-options-container .switch-context-button').removeClass('attention');

    if($('.bv3-col-first').is(':visible')) {
      alignElements();

      // scroll up to the watch
      $('.bv3-main').stop().animate({
        'scrollTop': 0
      }, 400, 'swing');
    } else {
      // show the watch container
      $('.bv3-col-first').slideDown(400, function(){
        alignElements();

        // fade in the watch layer groups - initially hidden so distorted watch images are hidden until alignElements() can run
        $('.bv3-col-first .bv3-watch-container').css('opacity', '1');

        // scroll up to the watch
        $('.bv3-main').stop().animate({
          'scrollTop': 0
        }, 400, 'swing', function(){

        });
      });
    }
  }

  // handles switching between option views
  function changeView(view) {
    // console.log(view);

    // if window is <= 1023px wide (mobile) scroll to the options container
    if(window.innerWidth <= 1023) {
      // set the options container offset based on the visible watch state
      if($('.bv3-col.bv3-col-first').is(':visible')) {
        var optionsOffset = $('.bv3-col.bv3-col-first').outerHeight();
      } else {
        var optionsOffset = 0;
      }

      $('.bv3-main').stop().animate({
        'scrollTop': optionsOffset
      }, 400, 'swing');
    }

    // replace the initial "get started" text with generic "next" and stop the initial next button animation
    $('.button-next').text('Next').css({'animation':'none', '-webkit-animation':'none'});

    // show the mobile only switch context button if it's not already visible
    if(!$('.switch-context-button').is(':visible')) { $('.switch-context-button').slideDown(); }

    // if 'next' or 'back' are passed to the function, execute the change
    if(view == 'next') {
      $('.bv3-options-block:visible').hide().next().show();
    } else if(view == 'back') {
      $('.bv3-options-block:visible').hide().prev().show();
    } else { // if not we want to use the passed value
      // hide the currently visible view and show the appropriate view based on the passed value
      $('.bv3-options-block:visible').hide();
      $('.bv3-options-block.options-' + view).show();
    }

    // if the view variable only contains "back" or "next", update the it with what the new view is
    if(view == 'back' || view == 'next') {
      view = $('.bv3-options-block:visible').attr('data-id');
      // console.log(view);
    }

    // handle the buttons & current nav indicator
    if(view != 'welcome' && view != 'review') {
      // if we're on any view except welcome or review
      $('.bv3-options-footer .button-back').css('display','inline-block');
      $('.bv3-options-footer .button-next').css('display','inline-block');

      // toggle the 'current' class on the appropriate nav icon (unless it's the review view)
      $('.bv3-options-container .section-nav:visible').removeClass('current');
      $('.bv3-options-container .section-nav.nav-' + view).addClass('current');

      // make sure the 'next' button text says the right thing
      // updating it to say 'review' when on the engraving view
      if(view == 'engraving') {
        $('.bv3-options-footer .button-next').text('Review');
      } else {
        $('.bv3-options-footer .button-next').text('Next');
      }

      // update the builder URL to reflect that we're not on the review view
      builderUrlHandler(null, false)
    } else if(view == 'welcome') {
      // show the next button and hide the back button
      $('.bv3-options-footer .button-back').css('display','none');
      $('.bv3-options-footer .button-next').css('display','inline-block');

      // hide the current indicator
      $('.bv3-options-container .section-nav:visible').removeClass('current');
    } else if(view == 'review') {
      // show the back button and hide the next button
      $('.bv3-options-footer .button-back').css('display','inline-block');
      $('.bv3-options-footer .button-next').css('display','none');

      // hide the current indicator
      $('.bv3-options-container .section-nav:visible').removeClass('current');

      // update the builder URL to reflect that we've gotten to the review view
      builderUrlHandler(null, true)
    }

    // animate the "current selected" indicator line
    if($('.bv3-options-container .section-nav:visible').hasClass('current')) {
      var $el = $('.bv3-options-container .section-nav.current');
      var leftPos = $el.position().left,
          newWidth = $el.width();

      $('#current-indicator').stop().animate({
        left: leftPos,
        width: newWidth
      });
    } else {
      var animateWidth = $('#current-indicator').position().left + 15;

      $('#current-indicator').stop().animate({
        left: animateWidth,
        width: 0
      });
    }

    // show the scroll indicator if the view can be scrolled
    $('.options-' + view + ' .scroll-icon').hide(); // hide it first
    if(isScrollable('.options-' + view)){
      $('.options-' + view + ' .scroll-icon').delay(3000).fadeIn(); // on a delay
      // fade it out once the user starts scrolling
      $('.options-' + view).one('scroll', function(){ $(this).find('.scroll-icon').fadeOut(); });
    }
  }

  // swap out the displayed watch dial with the one selected by the user
  function changeDialVariant(variantName, variantId, variantImgUrl, variantImgUrl2) {
    // if the clicked dial is already selected (indicated by the 'dial selected' class) then do nothing
    if($('.bv3-dial a[data-image-id="'+ variantId +'"]').parent().parent().hasClass('option-selected')) {
      return false;
    } else {
      // show the loading animation
      $('.bv3-loader').each(function(){
        $(this).fadeIn();
      });

      // remove the class "option-selected" from any dial that was previously selected
      $('.bv3-dial .dial-left').removeClass('option-selected');

      // update the "option-selected" class with the newly selected dial
      $('.bv3-dial a[data-image-id="'+ variantId +'"]').parent().addClass('option-selected');
      // $('.dial-left.option-image.option-selected').css('opacity','1');
      // $('.dial-left.option-image:not(.option-selected)').css('opacity','0.7');

      // select the hidden dropdown option for the variant
      $('#productSelect #'+ variantId).prop('selected', true);

      // swap in the variant image
      $('#bv3-layer-1.layer-front-dial img').fadeOut(250, function(){
        // set the src to '' to reset the onload event listener - a bit hacky but it works in safari
        $(this).attr('src','');
        // swap in the newly selected variant image
        $(this).attr({'src': variantImgUrl, 'alt': variantName}).load(function(){ alignElements('changeDialVariant'); $(this).fadeIn(); loaderHandler(); });
      });

      $('#bv3-layer-5.layer-back-movement img').fadeOut(250, function(){
        // set the src to '' to reset the onload event listener
        $(this).attr('src','');
        // swap in the newly selected variant image
        $(this).attr({'src': variantImgUrl2, 'alt': variantName}).load(function(){ alignElements('changeDialVariant'); $(this).fadeIn(); loaderHandler(); });
      });

      // update the review section with the selected options
      $('#review-dial .review-option-selected').text($('#productSelect option:selected').text());

      // update the global selectedDial variable
      selectedDial = variantId;
    }

    // update the total watch price
    priceHandler();

    // show or hide the add to cart button
    reviewHandler();

    // update the URL with the selected components
    builderUrlHandler();

    // build the watch share image
    buildWatchImg();
  }

  // check to see if all components are selected, updating the global variables at the same time
  function componentsSelected() {
    // update the selected component global variables
    // selectedDial is updated independently by the changeDialVariant function
    selectedCase = $('.bold_option_title:contains("Case Finish")').next().find('input:checked').val();
    selectedCrown = $('.bold_option_title:contains("Crown Style")').next().find('input:checked').val();
    selectedStrap = $('.bold_option_title:contains("Strap Type")').next().find('input:checked').val();
    selectedExtraStrap = $('.bold_option_title:contains("Additional Strap")').next().find('input:checked').val();
    selectedEngraving = []; // reset
    $('.bold_option_title:contains("Engraving")').next().find('.bold_option_value .bold_option_value_element input[type=checkbox]:checked').each(function(i){
      selectedEngraving[i] = $(this).val();
    });

    if(selectedDial != undefined && selectedCase != undefined && selectedCrown != undefined && selectedStrap != undefined) {
      return true;
    } else {
      return false;
    }
  }

  // update the total watch price
  function priceHandler() {
    // this is cosmetic only, as the product options app doesn't add the variant price to the total options price; it doesn't change the price when adding to cart, as the variant and option prices are handled by shopify separately

    // console.log('priceHandler triggered');

    // make sure the product options app total price is ALWAYS hidden because we're displaying the price elsewhere
    $('#option_total').css('display','none!important');

    // if no dial has been selected yet, make sure the price is displayed as $0
    if(selectedDial == undefined) {
      var priceFormatted = '0.00';
    } else {
      // get the price of the selected variant from the data-price attribute
      var variantPrice = $('#productSelect').find('option:selected').attr('data-price');

      // get the raw option total and strip the currency formatting to get a raw integer
      var optionsTotal = $('.bold_option_total div span .money').text();
      var optionsTotalStripped = Number(optionsTotal.replace(/[^0-9\.]+/g,""));

      // add the variant price to the options price (need to remove the comma from the variantPrice, otherwise parseFloat treats the comma as a decimal point)
      var addedPrice = parseFloat( variantPrice.replace(/,/g,'') ) + parseFloat(optionsTotalStripped);

      // assign the final price variable
      var finalPrice = parseInt(addedPrice);

      // if the final price is a negative value, set it to zero
      if(finalPrice < 0) { finalPrice = 0; }

      // set the updated price for affirm and trigger the ui update
      $('.affirm-as-low-as').attr('data-amount', finalPrice + '00');
        // setTimeout(function(){
        affirm.ui.refresh();
        // }, 250);

      // format the total price
      var priceFormatted = finalPrice.format(2);
    }

    // add to total price field
    $('.watch-total-price').each(function(){
      $(this).text('$' + priceFormatted);
    });

    // setTimeout(function(){ $('#option_total').css('display','none!important'); }, 250);
  }

  // manage the review view elements
  function reviewHandler() {
    // we don't want someone to be able to add a watch build to cart without all options selected (or share it)
    // if all options are selected then show the cart detail elements, otherwise hide them
    if(componentsSelected()) {
      $('.review-cart-item').show();
      $('.review-incomplete').hide();
      $('.review-info').show();
      $('.share-watch-build').show();
    } else {
      $('.review-cart-item').hide();
      $('.review-info').hide();
      $('.share-watch-build').hide();
    }

    // set the selected options in the review view
    $('#review-case .review-option-selected').html(selectedCase);
    $('#review-crown .review-option-selected').html(selectedCrown);
    $('#review-strap .review-option-selected').html(selectedStrap);
    if(selectedEngraving.length > 0) {
      $('#review-engraving .review-option-selected').html(selectedEngraving.join("<br> "));
    } else {
      $('#review-engraving .review-option-selected').html('None');
    }
  }

  // manages the loader icon, only hiding it after all watch images are fully loaded
  function loaderHandler(init) {
    // console.log('loadhandler triggered');

    // if the builder is being initialized
    if(init) {
      // show the load message on a delay, but only if the loader icon is visible
      setTimeout(function(){
        if($('.bv3-loader').css('display') != 'none') {
          $('.bv3-load-message').fadeIn();
        }
      }, 2000);
    }

    // check to see if all of the watch elements are visible (they're set to display after loading is complete)
    if($('.layer-front-case img').css('display') != 'none' &&
       $('.layer-front-crown img').css('display') != 'none' &&
       $('.layer-front-strap img').css('display') != 'none' &&
       $('.layer-front-dial img').css('display') != 'none' &&
       $('.layer-back-movement img').css('display') != 'none' &&
       $('.layer-back-strap img').css('display') != 'none' &&
       $('.layer-back-case img').css('display') != 'none') {

      // console.log('loadhandler all components visible');

      alignElements('loaderhandler');

      $('.bv3-loader').fadeOut();
      $('switch-context-button img').fadeOut();

      // trigger the mobile context switch button animations to start again
      $('.bv3-options-container .switch-context-button').removeClass('attention');
      setTimeout(function(){ $('.bv3-options-container .switch-context-button').addClass('attention'); }, 100);

      setTimeout(function(){
        $('.bv3-load-message').fadeOut();

        layerHandler();
      }, 250);

      // build the watch share image
      buildWatchImg();
    }
  }

  // manages the watch component layers
  function layerHandler() {
    // check to see if the watch placeholder image exists
    if($('.bv3-layer.layer-front-placeholder').length != 0) {
      // if all visual components are selected, hide the watch placeholder image
      if(componentsSelected()) {
        // fade out the placeholder image
        $('.bv3-layer.layer-front-placeholder').fadeOut(400, function(){
          // then remove it
          $(this).remove();

          // animate the front and back watch layer groups
          $('.bv3-watch-front .bv3-layer').css({
            'left': '40%'
          });

          $('.bv3-watch-back .bv3-layer').css({
            'opacity': '1',
            'left': '60%'
          });

          // now that both watch layer groups are visible
          // do this on a delay so the js & css animations don't overlap and cause slowdown
          setTimeout(function(){
            // fade out the complete selection message
            $('.complete-selection-message').fadeOut(400, function(){
              // then fade the switch button in
              $('.swap-layer-button').fadeIn();
            });
          }, 400);
        });
      } else if(selectedCase != undefined) {
        // if the case has been selected, lower the opacity of the placeholder image (this needs to happen *after* componentsSelected is run so we're sure the option variable are up to date)
        $('.bv3-layer.layer-front-placeholder').css('opacity','.1');
      }
    }
    // console.log($('.bv3-layer.layer-front-placeholder').length + ', ' + selectedCase + ', ' + selectedCrown + ', ' + selectedStrap);
  }

  function isScrollable(el) {
    return $(el)[0].scrollHeight > $(el)[0].offsetHeight;
  }


///////////////////////////////////////////////////////////
// Tertiary Functions (additional features)
///////////////////////////////////////////////////////////

  // handles switching between the front and the back of the watch being the top-most layer
  function swapLayerOrder() {
    // get the width of the case image and use that for the animation calculation
    var containingWidth = parseInt($('#bv3-layer-2 img').width()),
        animatePx = containingWidth / 3.5;

    if($('.bv3-watch-back.bv3-layer-group').css('z-index') == '5') {
      $('.bv3-watch-front.bv3-layer-group').css({'left': '-=' + animatePx + 'px'});
      $('.bv3-watch-back.bv3-layer-group').css({'left': '+=' + animatePx + 'px'});
      setTimeout(function(){
        $('.bv3-watch-back.bv3-layer-group').css({'z-index': '7', 'left': ''});
        $('.bv3-watch-front.bv3-layer-group').css({'left': ''});
      }, 500);
    } else {
      $('.bv3-watch-front.bv3-layer-group').css({'left': '-=' + animatePx + 'px'});
      $('.bv3-watch-back.bv3-layer-group').css({'left': '+=' + animatePx + 'px'});
      setTimeout(function(){
        $('.bv3-watch-back.bv3-layer-group').css({'z-index': '5', 'left': ''});
        $('.bv3-watch-front.bv3-layer-group').css({'left': ''});
      }, 500);
    }
  }

  // handles filtering of dials/movements
  function filterHandler(clickedFilter) {
    // set the currentFilter variable to match the just clicked filter, stop the function if the already selected filter was clicked again
    if(clickedFilter != currentFilter) {
      currentFilter = clickedFilter;
    } else {
      return;
    }

    // filter based on the passed argument
    // show all dials
    if(clickedFilter == 'all') {
      $('.bv3-dial').show();
      $('.options-filter').removeClass('selected');
      $('#filter_all').addClass('selected');
    }

    // filter by price - low
    else if(clickedFilter == 'low') {
      $('.bv3-dial').each(function(){
        if($(this).attr('data-price') < filterPriceLow) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
      $('.options-filter').removeClass('selected');
      $('#filter_low').addClass('selected');
    }

    // filter by price - mid
    else if(clickedFilter == 'mid') {
      $('.bv3-dial').each(function(){
        if($(this).attr('data-price') > filterPriceLow && $(this).attr('data-price') < filterPriceHigh) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
      $('.options-filter').removeClass('selected');
      $('#filter_mid').addClass('selected');
    }

    // filter by price - high
    else if(clickedFilter == 'high') {
      $('.bv3-dial').each(function(){
        if($(this).attr('data-price') > filterPriceHigh) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
      $('.options-filter').removeClass('selected');
      $('#filter_high').addClass('selected');
    }
  }

  // handles copying the save URL to the clipboard
  function copyUrl() {
    // select the input text, copy it to the clipboard, and then alert the user
    $('.save-url-input').select();
    document.execCommand("copy");
    $('.url-copy-alert').slideDown();
  }

  // whenever the watch build changes, update the url with the appropriate arguments for saving
  // also returns the build url for saving for use when the "save this watch" button is clicked
  function builderUrlHandler(action, review) {
    if(action == 'reset') {
      // reset the URL - replaceState() is reliable, but I don't love it because it manipulates browser history and only works in newer (HTML5 supporting) browsers
      window.history.replaceState("", "", window.location.pathname);
    } else {
      // set defaults for engraving and then override the options that are selected
      var wEngrave = false;
      $('.bold_option_title:contains("Engraving")').next().find('.bold_option_value').each(function(index){
        if( $(this).find('input:checked').val() != undefined ) {
          if(index == 0) { wEngrave = true; }
        }
      });

      // console.log('Selected options: '+selectedDial+', '+selectedCase+', '+selectedCrown+', '+selectedStrap+', '+wEngrave);

      // if we're initializing the builder, this function will be triggered once before the saved options are selected
      // so we want to prevent the undefined options from bungling the saved build initialization
      if(!componentsSelected()) { return false; }

      // handle review arg for analytics purposes
      if(review == true) {
        if($('body').hasClass('product-watch-builder-v3-aas')) {
          review = 'aas-review';
        } else if($('body').hasClass('product-watch-builder-v3-railroad')) {
          review = 'rr-review';
        } else { review = false; }
      } else {
        review = false;
      }

      // build the url parameters
      var urlArgs = '?dial=' + encodeURIComponent(selectedDial) +
                    '&case=' + encodeURIComponent(selectedCase) +
                    '&crown=' + encodeURIComponent(selectedCrown) +
                    '&strap=' + encodeURIComponent(selectedStrap) +
                    '&engrave=' + encodeURIComponent(wEngrave) +
                    '&r=' + review;

      // update the url - this is the default function behavior
      window.history.replaceState("", "", window.location.pathname + urlArgs);

      // update the url field in the save dialog
      $('.save-url-input').attr('value', window.location.href).attr('data-clipboard-text', window.location.href);

      // update the save url in the hidden line item - this enables customers to go back from the cart and edit their option selections
      $('#edit-link').val(window.location.href);
    }
  }

  // handles creating the imgix url which combines all of the component images to build a final image of the watch
  function buildWatchImg() {
    // set variables to replace the shopify image cdn url with the imgix url and manually set a custom image size on all of the component images
    var cdnUrl = 'https://cdn.shopify.com',
        imgixUrl = 'https://vortic.imgix.net';

    // get the selected watch component images witgh a few different steps:
      // - replace the cdnUrl with the imgixUrl
      // - add on necessary imgix arguments for special processing
      // - ready for base64 encoding
    var frontCrownUrl = $('.layer-front-crown img').attr('src').replace(cdnUrl, imgixUrl).concat('&auto=compress,format'),
        frontCaseUrl = $('.layer-front-case img').attr('src').replace(cdnUrl, imgixUrl).concat('&markalign=top,center&auto=compress,format&mark64='),
        backCaseUrl = $('.layer-back-case img').attr('src').replace(cdnUrl, imgixUrl);

    // dial and movement, and front and back strap image size - in addition to the above steps, determine the correct size based on the builder being used - change it if it's not the standard builder
    var componentImgSize = '700';
    if (thisBuilder == 'railroad') { componentImgSize = '825'; }
    var frontDialUrl = $('.layer-front-dial img').attr('src').replace(cdnUrl, imgixUrl).concat('&markw=' + componentImgSize + '&w=' + componentImgSize + '&pad=115&markalign=center,middle&auto=compress,format&mark64='),
        backMovementUrl = $('.layer-back-movement img').attr('src').replace(cdnUrl, imgixUrl).concat('&markw=' + componentImgSize + '&w=' + componentImgSize + '&pad=125&markalign=center,middle&auto=compress,format&mark64='),
        frontStrapUrl = $('.layer-front-strap img').attr('src').replace(cdnUrl, imgixUrl).concat('&w=' + componentImgSize + '&markalign=center,middle&auto=compress,format&mark64='),
        backStrapUrl = $('.layer-back-strap img').attr('src').replace(cdnUrl, imgixUrl).concat('&w=' + componentImgSize + '&markalign=center,middle&auto=compress,format&mark64=');

    // build and stack the URLS for the front image
      // layer the encoded crown onto the case image, replacing slashes with underscores and removing trailing equal signs for safe URLs for imgix
      // console.log('frontCrownUrl ' + frontCrownUrl);
      // console.log('frontCaseUrl ' + frontCaseUrl);
      // console.log('frontDialUrl ' + frontDialUrl);
      // console.log('frontStrapUrl ' + frontStrapUrl);

      var frontCrownEncoded = btoa(frontCrownUrl);
      var frontCrownEncoded = frontCrownEncoded.replace('/','_');
      var frontCrownEncoded = frontCrownEncoded.replace('=','');
      var frontCrownCaseUrl = frontCaseUrl.concat(frontCrownEncoded);
          // console.log('frontCrownCaseUrl ' + frontCrownCaseUrl);

      // layer the encoded crown+case onto the dial image, replacing slashes with underscores and removing trailing equal signs for safe URLs for imgix
      var frontCrownCaseEncoded = btoa(frontCrownCaseUrl);
      var frontCrownCaseEncoded = frontCrownCaseEncoded.replace('/','_');
      var frontCrownCaseEncoded = frontCrownCaseEncoded.replace('=','');
      var frontCrownCaseDialUrl = frontDialUrl.concat(frontCrownCaseEncoded);
          // console.log('frontCrownCaseDialUrl ' + frontCrownCaseDialUrl);

      // layer the encoded crown+case+dial onto the strap image, replacing slashes with underscores and removing trailing equal signs for safe URLs for imgix
      var frontCrownCaseDialEncoded = btoa(frontCrownCaseDialUrl);
      var frontCrownCaseDialEncoded = frontCrownCaseDialEncoded.replace('/','_');
      var frontCrownCaseDialEncoded = frontCrownCaseDialEncoded.replace('=','');
      var frontCrownCaseDialStrapUrl = frontStrapUrl.concat(frontCrownCaseDialEncoded);
          // console.log('frontCrownCaseDialStrapUrl ' + frontCrownCaseDialStrapUrl); // - done with the front

    // build and stack the URLS for the back image
      // build the case+movement image, replacing slashes with underscores and removing trailing equal signs for safe URLs for imgix
      var backCaseEncoded = btoa(backCaseUrl);
      var backCaseEncoded = backCaseEncoded.replace('/','_');
      var backCaseEncoded = backCaseEncoded.replace('=','');
      var backCaseMovementUrl = backMovementUrl.concat(backCaseEncoded);
          // console.log('backCaseMovementUrl ' + backCaseMovementUrl);

      // layer the case+movement onto the strap image, replacing slashes with underscores and removing trailing equal signs for safe URLs for imgix
      var backCaseMovementEncoded = btoa(backCaseMovementUrl);
      var backCaseMovementEncoded = backCaseMovementEncoded.replace('/','_');
      var backCaseMovementEncoded = backCaseMovementEncoded.replace('=','');
      var backCaseMovementStrapUrl = backStrapUrl.concat(backCaseMovementEncoded);
          // console.log('backCaseMovementStrapUrl ' + backCaseMovementStrapUrl); // - done with the back

    // prep the background image - the background image will be the final filename that the user will download from imgix once the final image is compiled - bg image is 1250x1400
    var finalWatchImg = 'https://vorticwatches.com/cdn/shop/t/48/assets/vortic_watch_builder.jpg?v=42165918109312514841764193153';

    // build the final image
      // layer the encoded final watch-back image onto the background image, replacing slashes with underscores and removing trailing equal signs for safe URLs for imgix
      var finalFrontEncoded = btoa(frontCrownCaseDialStrapUrl);
      var finalFrontEncoded = finalFrontEncoded.replace('/','_');
      var finalFrontEncoded = finalFrontEncoded.replace('=','');
      var finalBackEncoded = btoa(backCaseMovementStrapUrl);
      var finalBackEncoded = finalBackEncoded.replace('/','_');
      var finalBackEncoded = finalBackEncoded.replace('=','');

      // build the final image url - if this is the railroad builder then the size needs to change
      var finalImgSizeW = '1250', finalImgSizeH = '1400';
      if (thisBuilder == 'railroad') { finalImgSizeW = '1473'; finalImgSizeH = '1650'; }
      var finalWatchImg = finalWatchImg.replace(cdnUrl, imgixUrl).concat('&w=' + finalImgSizeW + '&h=' + finalImgSizeH + '&markalign=right,middle&mark64=' + finalBackEncoded + '&ba=left,middle&bm=normal&auto=compress,format&blend64=' + finalFrontEncoded);
      var finalWatchImg = finalWatchImg.replace('=&','&');

      // add the watch image url and builder url to the share form hidden property fields
      $('.share-form .shareWatchImgUrl').each(function(){ $(this).attr('value',finalWatchImg); });
      $('.share-form .shareWatchUrl').each(function(){ $(this).attr('value', window.location.href); });

      // update the compiled imgix watch image url in the hidden line item - this enables customers to see the watch image in the shopping cart as well as their order confirmation email
      $('#watch-img-url').val(finalWatchImg);
      // console.log('finalWatchImg: ' + finalWatchImg);
  }

  // handles showing the "email this watch" form section on the review view
  function showShareForm() {
    $('.share-form').slideDown();
    $('.share-error').slideUp();
    $('.share-success').slideUp();
  }

  // handles the founders pick popover and video creation
  function foundersPick($el) {
    // get the video id
    var videoId = $el.attr('data-video-id'),
        movementDetails = $el.attr('data-mvmnt');

    // create the vex popover
    vex.dialog.buttons.YES.text = 'Back to the Builder';
    vex.dialog.alert({
      contentClassName: 'bv3-popover founders-pick-popover',
      className: 'vex-theme-default',
      message: movementDetails + '<div class="founders-pick-video"></div>',
      afterOpen: function() {
        // create the vimeo player within the popover
        var videoWrapper = $('.founders-pick-video'),
            videoOptions = {
              id: videoId,
              autoplay: true,
              width: '640',
              byline: false,
              title: false,
              portrait: false
            };
        var mvmntVideo = new Vimeo.Player(videoWrapper, videoOptions);
      }
    });
  }

  // disables the builder for the user, for use while movements or options are being updated
  function devUpdateMode() {
    if(window.location.search.substring(1) != 'devmode') {
      $('.bv3-main').hide();

      vex.dialog.buttons.YES.text = 'OK, Go Back';
      vex.dialog.alert({
        message: '<h3>The watch builder is currently being updated with new dials, movements, and customization options.</h3><h3>Check back in a little bit.</h3>',
        contentClassName: 'bv3-popover',
        className: 'vex-theme-default',
        callback: function() {
          window.history.go(-1);
          return false;
        }
      });
    }
  }

  // restricted access modal for anyone who accesses the builder without permission
  function accessMessageHandler(customer) {
    $('.bv3-main').remove();

    // not logged in
    if(!customer) {
      vex.dialog.buttons.YES.text = 'OK, Go Back';
      vex.dialog.alert({
        message: '<h3>You do not have permission to view this watch builder. If you believe you have received this message in error <a href="/account" style="text-decoration: underline; color: #bc8420; font-weight: 400;">try logging in to your Vortic Customer account</a> and then revisit this page.',
        contentClassName: 'bv3-popover',
        className: 'vex-theme-default',
        callback: function() {
          window.location.href = "/watches";
          return false;
        }
      });
    }
    // logged in but improper permission
    else {
      vex.dialog.buttons.YES.text = 'OK, Go Back';
      vex.dialog.alert({
        message: '<h3>You do not have permission to view this watch builder.',
        contentClassName: 'bv3-popover',
        className: 'vex-theme-default',
        callback: function() {
          window.location.href = "/watches";
          return false;
        }
      });
    }




  }